import { render, staticRenderFns } from "./changerecord.vue?vue&type=template&id=2d34fd64"
import script from "./changerecord.vue?vue&type=script&lang=js"
export * from "./changerecord.vue?vue&type=script&lang=js"
import style0 from "./changerecord.vue?vue&type=style&index=0&id=2d34fd64&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DealerModule: require('/root/workspace/web-company_Yo6Q/components/dealer/head/dealerModule.vue').default})
